import React from "react";
import { Outlet } from "react-router-dom";

const Services = () => {
  return <Outlet />;
};

export default Services;
